module.exports = __webpack_public_path__ + "img/crossword.db757372.svg";